"use client";
import React from "react";
import { CategoryProps } from "./type";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";

// 自定义面包屑项样式
const StyledBreadcrumb = styled(Link)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "18px",
  color: "#888B94",
  textDecoration: "none",
  "&.active": {
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "20px",
    color: "#1A1A1A",
  },
}));
// 自定义分隔符样式
const CustomSeparator = styled("div")({
  marginLeft: "6px",
  marginRight: "6px",
  color: "#C2C4CC",
});

const BasicBreadcumbs: React.FC<CategoryProps> = ({ data = [], searchParams }) => {
  const l1 = searchParams.l1;
  const l1Catename = data.filter((v) => v.cateName).find((v) => ~~v.cateId === ~~l1)?.cateName || "";
  const breadList = [{ name: "Home", href: "#" }, { name: l1Catename }];

  return (
    <Breadcrumbs separator={<CustomSeparator>/</CustomSeparator>} aria-label="breadcrumb" sx={{ margin: "32px 0 14px", minHeight: 24 }}>
      {breadList.map((item, index) =>
        index === breadList.length - 1 ? (
          <Typography sx={{ color: "#1A1A1A", fontWeight: 700, fontSize: 16 }} key={item.name}>
            {item.name}
          </Typography>
        ) : (
          <StyledBreadcrumb href={item.href || ""} style={index === 0 ? { cursor: "default" } : {}} key={item.name}>
            {item.name}
          </StyledBreadcrumb>
        ),
      )}
    </Breadcrumbs>
  );
};

export default BasicBreadcumbs;
